/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CostflowDto } from '../../models/costflow-dto';

export interface GetEstimatedCostflow$Params {
  projectId: string;
  budgetIds?: Array<string>;
  isLabor?: boolean | null;
  costTypesIds?: Array<string>;
  workPackageIds?: Array<string>;
  from?: string | null;
  to?: string | null;
}

export function getEstimatedCostflow(http: HttpClient, rootUrl: string, params: GetEstimatedCostflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CostflowDto>> {
  const rb = new RequestBuilder(rootUrl, getEstimatedCostflow.PATH, 'get');
  if (params) {
    rb.query('projectId', params.projectId, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('isLabor', params.isLabor, {});
    rb.query('costTypesIds', params.costTypesIds, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CostflowDto>;
    })
  );
}

getEstimatedCostflow.PATH = '/v0/Costflow/estimated';
